export default "__VITE_ASSET__5225c587__"